import React from "react";
import { getFormattedNames, getSpecOrClassIcon } from "../../../lib/wowHelpers";
import Icon from "../../Common/Icon";
import CopyTalentsButton from "../../Common/CopyTalentsButton";
import MediaQuery from "components/MediaQuery";

const ProbuildsTalentTreeHeader = ({ treeType, classType, specType, isClassTree }) => {
  const { displayClassName, displaySpecName, dataClassName, dataSpecName } = getFormattedNames(classType, specType);
  const treeLabel = treeType == "spec" ? displaySpecName : displayClassName;
  const icon = getSpecOrClassIcon(isClassTree, dataClassName, dataSpecName);

  return isClassTree ? (
    <div className="probuilds-talent-tree-header-container">
      <div className="header-sans-copy">
        <div className="content-section-title">Talent Build</div>
        <div className="class-spec-title">
          <Icon iconSize="20px" classType={"circle"} staticDataImg={icon} />
          <div className="tree-label">{treeLabel} Talents</div>
        </div>
      </div>
      <MediaQuery min="MOBILE_SMALL" max="TABLET" renderNullOnFail>
        <CopyTalentsButton label="Copy" />
      </MediaQuery>
    </div>
  ) : (
    <div className="probuilds-talent-tree-header-container">
      <div className="class-spec-title">
        <Icon iconSize="20px" classType={"circle"} staticDataImg={icon} />
        <div className="tree-label">{treeLabel} Talents</div>
      </div>
      <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE" renderNullOnFail>
        <CopyTalentsButton label="Copy" />
      </MediaQuery>
    </div>
  );
};

export default ProbuildsTalentTreeHeader;
